import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { PhoneIcon, MailIcon, MapPinIcon, ShieldIcon } from "../assets/icons";
import "./Contact.css";

const Contact = () => {
  const formRef = useRef();
  const [isSending, setIsSending] = useState(false);
  const [status, setStatus] = useState({ type: "", text: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);
    setStatus({ type: "", text: "" });

    // Ingest keys directly from your local environment map
    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    emailjs.sendForm(serviceID, templateID, formRef.current, publicKey).then(
      () => {
        setIsSending(false);
        setStatus({
          type: "success",
          text: "Email sent! We will get back to you as soon as possible.",
        });
        formRef.current.reset(); // Automatically wipes out form data on successful send
      },
      (error) => {
        setIsSending(false);
        console.error("EmailJS Service Interrupt:", error);
        setStatus({
          type: "error",
          text: "Failed to send Email. Please try to message us directly.",
        });
      },
    );
  };

  return (
    <section className="section-padding">
      <div className="container contact-layout">
        {/* ---------- LEFT COLUMN: CHANNEL DIRECTORY ---------- */}
        <div className="contact-info">
          <h2 className="section-title">
            Let’s <span className="accent-text">Talk</span>
          </h2>
          <p className="contact-intro">
            We’d love to hear about your project. Reach out and we’ll respond
            within one business day. <strong>More than just technology</strong>{" "}
            — your digital journey starts here.
          </p>

          <div className="info-items">
            <div className="info-item">
              <PhoneIcon size={24} stroke="var(--sun-primary)" />
              <div>
                <strong>Phone</strong>
                <span>+27 82 546 8309</span>
              </div>
            </div>
            <div className="info-item">
              <MailIcon size={24} stroke="var(--sun-primary)" />
              <div>
                <strong>Email</strong>
                <span>info@kafuetechnologies.com</span>
              </div>
            </div>
            <div className="info-item">
              <MapPinIcon size={24} stroke="var(--sun-primary)" />
              <div>
                <strong>Office</strong>
                <span>Pretoria, Gauteng, South Africa</span>
              </div>
            </div>
          </div>

          <div
            className="sla-notice-box"
            style={{
              marginTop: "2rem",
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
              fontSize: "0.9rem",
              opacity: 0.8,
            }}
          >
            <ShieldIcon size={18} stroke="var(--sun-primary)" />
            <span>
              All inquiries are routed through automated secure parameters.
            </span>
          </div>
        </div>

        {/* ---------- RIGHT COLUMN: INTERACTIVE EMAILJS FORM ---------- */}
        <div className="contact-form-holder">
          <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
            <h3>Send a Message</h3>
            <p
              style={{
                fontSize: "0.9rem",
                color: "#666",
                marginBottom: "0.5rem",
              }}
            >
              Provide your details below to activate discovery.
            </p>

            {/* Dynamic Status Banner Alerts */}
            {status.text && (
              <div className={`status-banner ${status.type}`}>
                {status.text}
              </div>
            )}

            <input
              type="text"
              name="from_name"
              placeholder="Your Full Name"
              required
            />

            <input
              type="email"
              name="from_email"
              placeholder="Email Address"
              required
            />

            <input
              type="tel"
              name="phone_number"
              placeholder="Phone Number (optional)"
            />

            <select name="service_vector" required>
              <option value="">What Service Are You Interested In?</option>
              <option value="Website Design">Website Design</option>
              <option value="Web Application">Web Application</option>
              <option value="Hosting & Management">Hosting & Management</option>
              <option value="Email Services">Email Services</option>
              <option value="Other">Other</option>
            </select>

            <textarea
              name="project_scope"
              rows="5"
              placeholder="Tell us about your project..."
              required
            />

            <button type="submit" className="btn-primary" disabled={isSending}>
              {isSending ? "Sending Transmission..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
